const stDesk = {
  containHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
    padding: '0 5px',

    borderBottom: '1px solid #ccc',
    boxShadow: '0px 2px 2px 0px rgba(0,0,0,0.2)',
  },
  containCardHeader: {
    display: 'flex',
    width: 'auto',
    padding: '5px',
  },
  iconAvatar: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    marginRight: '5px',
    objectFit: 'cover',
  },
  containSubHeader: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    height: 'auto',
    width: '100%',
  },
  titleCardHeader: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '-3px',
  },
  labelCardHeader: {
    fontSize: '14px',
    color: 'gray',
  },
  containStatusPdd: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    height: 'auto',
    width: 'auto',
    padding: '5px',
  },
}

const stMob = {}

export { stDesk, stMob }
